export default Object.freeze({
  event    : 'event',
  pageview : 'pageview',
});
